<template>
  <div class="menu">
    <div v-if="platform === 'mobile'">
      <div class="pic">
        <img v-if="!info.brand" src="../img/eilis.png" style="transform: scale(1); margin-left: 10px;" alt="louisa logo"  width="100%">
        <img v-if="info.brand === 'NAUTICA'" src="../img/Nautica.png" style="transform: scale(0.8); margin-top: -100px;" alt="louisa logo"  width="100%">
        <img v-if="info.brand === 'Whittard'" src="../img/whittard.jpg" style="transform: scale(0.5); margin-top: -100px; z-index: 1"   width="100%">
        <img v-if="info.brand === 'Eden Park'" src="../img/Eden-Park.png" style="transform: scale(0.8); position:fixed; margin-top: -50px; left: 0%; z-index: 1" width="100%">
        <img v-if="info.brand === 'JEEP'" src="../img/JEEP.png" style="transform: scale(0.8); position:fixed; margin-top: -50px; left: 0%; z-index: 1" width="100%">
        <img v-if="info.brand === 'LIP SERVICE'" src="../img/LIP.jpg" style="transform: scale(0.8); position:fixed; margin-top: -50px; left: 0%; z-index: 1" width="100%">
      </div>
      <cube-loading :size="25" class="loadingIcon" v-if="loading"></cube-loading>
    </div>
    <!-- QR Code -->
    <div v-if="platform === 'desktop'">
      <div style="border: 1px solid #cbced3; display: inline-block; padding: 20px; padding-bottom: 12px; margin-top: 40px; width: 200px;">
        <qrcode-vue :value="qrcode" size="150" level="H"></qrcode-vue>
      </div>
      <div style="margin-top: 15px;">
        {{ $t('Login.no_service') }}<br>{{ $t('Login.scan_code') }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from 'vuex'
import QrcodeVue from 'qrcode.vue'

export default {
  data () {
    return {
      // whitelist: ['Uc050dc60f7ae39d758c3e9a52d4557e2'], // 2021/09/28 測試
      whitelist: ['Uc050dc60f7ae39d758c3e9a52d4557e2','Ue7fb9a5a61b0990c8baba37c0140dee8', 'Ue7fb9a5a61b0990c8baba37c0140dee9', 'U12cd87201b3aff4a062004d920ec482', 'U9efdca9d57774980c4d32d4d11f057b2', 'U9efdca9d57774980c4d32d4d11f057b1', 'U5e40bf2c39348a53054882025fd91695', 'U36ce5275b2050710c803b3a6395a12ec', 'Ue7fb9a5a61b0990c8baba37c0140dee8' , 'Ubafa00222c6de40e84072fcc8ccc2b5f'],
      // brand: this.$route.query.brand ? this.$route.query.brand : localStorage.getItem('brand'),,
      loading: false,
      platform: 'mobile',
      qrcode: '',
      platform: '',
      phoneVerify: false,
      Service: this.$route.params.service,
      alert: false,
      channelData: {
        AuthToken: this.$route.query.Auth,
        Service: this.$route.params.service,
        PhoneNumber: '',
        Name: this.$route.query.Name ? this.$route.query.Name : '',
        PageID: this.$route.query.Page,
        picture: '',
        date: this.$route.query.date
      },
    }
  },
  components: {
    QrcodeVue
  },
  mounted() {
    if (localStorage.getItem('brand')) {
      localStorage.removeItem('brand')
    }
    // console.log(this.$route.query.brand);
    this.brandID = this.$route.query.brand
    this.change = this.$route.query.brand
    // console.log(this.brandID);
    // console.log(this.change);
    // localStorage.clear(); // 清空
    // console.log(this.info.clientId);
    // this.loading = true;
    if (this.$route.params.service === 'FB') {
      // console.log('72');
      localStorage.setItem('brand',this.$route.query.brand);
    } else {
      // console.log('75');
      let brand = '';
      let channelId = '';
      const querystring = window.location.search;
      // console.log(querystring);
      if (querystring.indexOf('&brand=') === -1) {
        brand = querystring.split('%26brand%3D')[1];
      } else {
        brand = querystring.split('&brand=')[1];
      }
      // console.log(this.$route.query.brand);
      localStorage.setItem('brand',this.$route.query.brand);
    }
    // this.change = this.$route.query.brand //將this.equal 放到vuex
    this.classify();
    this.identify()
    // console.log(this.brandCode);
  },
  computed: {
    ...mapGetters({
      register: 'register',
      info: 'info',
      ruentexProfile: 'ruentexProfile',
      eilisProfile: 'eilisProfile',
      brandCode: 'brandCode'
    }),
    // equal() {
    //   // console.log(this.brand);
    //   if (this.info.brand === 'NAUTICA') {
    //     return 'NS';
    //   } else if (this.info.brand === 'JEEP') {
    //     return 'JP';
    //   } else if (this.info.brand === 'Eden Park') {
    //     return 'EP';
    //   } else if (this.info.brand === 'Lulu Guinness') {
    //     return 'LU';
    //   } else if (this.info.brand === 'Whittard') {
    //     return 'WH';
    //   } else if (this.info.brand === 'LIP SERVICE') {
    //     return 'LP';
    //   }
    // },
    brandID: {
      get () { return this.info.brand },
      set(value) { this.updateBrand({ brand: value }); },
    },
    change: {
      get () { return this.brandCode },
      set(value) { this.transform({ code: value }); },
    },
    ruFile: {
      get () { return this.ruentexProfile },
      set(value) { this.storeRuenFile({ Profile: value }); },
    },
    EFile: {
      get () { return this.eilisProfile },
      set(value) { this.storeEilisFile({ Efile: value }); },
    },
    channelId: {
      get () { return this.info.clientId },
      set(value) { this.updateClientId({ clientId: value }); },
    },
    brand_seeking: {
      get () { return this.infomation.brand },
      set(value) { this.updatebrand({ brand: value }); },
    },
  },
  methods: {
    ...mapMutations({
      updateClientId: 'updateClientId',
      storeRuenFile: 'storeRuenFile',
      storeEilisFile: 'storeEilisFile',
      transform: 'transform',
      updateBrand: 'updateBrand'
    }),
    ...mapActions({
      getUserData: 'getUserData',
      getAccessToken: 'getAccessToken',
      checkUserByToken: 'checkUserByToken',
      readMember: 'readMember',
    }),
    classify () {
      if (this.info.brand === 'NAUTICA') {
        this.channelId = '1655953868';
        localStorage.setItem('clientId', this.channelId)
      } else if (this.info.brand === 'JEEP') {
        this.channelId = '1655682944';
        localStorage.setItem('clientId', this.channelId)
      } else if (this.info.brand === 'Eden Park') {
        this.channelId = '1655280896';
        localStorage.setItem('clientId', this.channelId)
      } else if (this.info.brand === 'Lulu Guinness') {
        this.channelId = '';
        localStorage.setItem('clientId', this.channelId)
      } else if (this.info.brand === 'Whittard') {
        this.channelId = '1654333455';
        localStorage.setItem('clientId', this.channelId)
        // console.log(this.channelId);
      } else if (this.info.brand === 'LIP SERVICE') {
        this.channelId = '1656289509';
        localStorage.setItem('clientId', this.channelId)
        // console.log(this.channelId);
      }
    },
    month(val) {
      if (val < 10) {
          return '0'+ val;
      } else {
          return val
      }
    },
    date(val) {
      if (val < 10) {
          return '0'+ val;
      } else {
          return val
      }
    },
    identify() {
      // console.log('0');
      this.loading = true;
      if ( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.platform = 'mobile';
        if (this.channelData.Service === 'FB' || this.whitelist.indexOf(this.$route.query.Auth) !== -1) {
          this.Login();
        }
        else {
          this.LiffLogin();
        }
      } else {
        this.platform = 'desktop';
        const querystring = window.location.search;
        if (this.channelData.Service === 'FB') {
          this.qrcode = `http://m.me/${421955544535676}`;
        } else {
          this.qrcode = 'https://liff.line.me/1654949730-V7NB1G9Z';
        }
      }
    },
    Login() {
      this.checkUserByToken({ service: this.$route.params.service, token: this.channelData.AuthToken, clientId: this.info.clientId, })
      .then((res) => {
        // console.log(res);
        // this.platform = 'mobile';
        // console.log(Object.values(res.data));
        if (res.data.result === '查無此會員') {
          // return;
          this.$router.push(`/initial/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&Img=${this.channelData.picture}&brand=${this.$route.query.brand}`)
          this.loading = false;
        } else if (res.data.result.userId) {
          this.EFile = res.data.result;
          this.readMember({ brand: this.brandCode, clientId: res.data.result.userId, phone:res.data.result.phone })
          .then((res) => {
            // console.log(res);
            this.ruFile = res.data.result;
            this.$router.push(`/mainbottom/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&brand=${this.$route.query.brand}`)
            this.loading = false;
          })
          // setTimeout(() => {
          //   // return;
          //   // this.$router.push(`{ name: 'menu', params: { service: this.$route.params.service }}?Auth=${this.channelData.AuthToken}&Page=${this.channelData.PageID}&trigger=${this.channelData.trigger}`)
          //   this.$router.push(`/mainbottom/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&Page=${this.channelData.PageID}`)
          //   this.loading = false;
          // },1000)
        } else if (res.data.Message === '查無此用戶') {
          this.loading = false;
        }
      })
      .catch((err) => {
        this.loading = false;
        alert(err)
      })
    },
    LiffLogin() {
      let liffId = '';
      const querystring = window.location.search;
      // console.log(querystring);
      if (querystring.indexOf('liffid=') !== -1) {
        liffId = querystring.split('liffid=')[1].split('&brand=')[0]
        // localStorage.setItem('liffId', liffId);
        liff.init({
          liffId: liffId
        })
        .then(() => {
        liff.getProfile()
          .then((profile) => {
            this.channelData.AuthToken = profile.userId;
            this.channelData.picture = profile.pictureUrl;
            this.Login();
          })
        })
        .catch((err) => {
          // alert(err);
          alert('已離開會員卡。');
          liff.closeWindow();
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
      /* Absolute Center Spinner */
  .loadingIcon {
    display: flex; // 置中
    align-items: center; // 置中
    justify-content: center; // 置中
    margin: 0 auto;
    position: fixed;
    margin: 0 auto;
    position: fixed;
    top: 70%;
    left: 0;
    right: 0;
  }
  .menu {
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    max-width: 540px;
    min-width: 300px;
    height: 750px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  .pic {
    position: fixed;
    z-index: 10000;
    margin-top: 35%;
    margin-left: 10px;
    -webkit-animation-name: myframes;
            animation-name: myframes;
    -webkit-animation-duration: 300ms;
            animation-duration: 300ms;
    -webkit-animation-timing-function: ease-in-out;
            animation-timing-function: ease-in-out;
    -webkit-animation-delay: 0s;
            animation-delay: 0s;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-animation-direction: normal;
            animation-direction: normal;
    -webkit-animation-fill-mode: forwards;
            animation-fill-mode: forwards;
  }
.box.is-paused {
  -webkit-animation-play-state: paused;
          animation-play-state: paused;

}
@keyframes myframes {
  0% {
    // -webkit-transform: scale(1) translateX(200px) rotate(0deg);
    //         transform: scale(1) translateX(200px) rotate(0deg);
    opacity: 0.1;
  }
  // 50% {
  //   -webkit-transform: scale(0.5) rotate(0deg);
  //           transform: scale(0.5) rotate(0deg);
  //   opacity: 0.5;
  // }
  // 80% {
  //   -webkit-transform: scale(0.8) rotate(0deg);
  //           transform: scale(0.8) rotate(0deg);
  //   opacity: 0.8;
  // }
  100% {
    // -webkit-transform: scale(1) translateX(0px) rotate(0deg);
    //         transform: scale(1) translateX(0px) rotate(0deg);
    opacity: 1;
  }
}
</style>
